import TranslationText from '@Components/Utilities/TranslationText';
import { useWindowSize } from '@Components/Utilities/WindowSize';

const FullBlogSection = (props) => {
    const blogs = props.Blogs ? (props.maxNumBlogs ? props.Blogs.slice(0, props.maxNumBlogs) : props.Blogs) : [];
    const windowSize = useWindowSize();

    return (blogs && blogs.length > 0 &&
        <div className='blog-section'>
            <h2 className='section-title'>
                <span className='section-title-text'>
                    {props.CurrentSiteFullDomain + ' '} <TranslationText tKey='sandhills.blog' />
                </span>
                {!windowSize.isMobile && <a id='home-page-blog-archive' className='button ts-button blog-button' href={props.BlogArchiveURL}>
                    <TranslationText tKey='sandhills.viewallblogposts' />
                </a>}
            </h2>
            <div className='blog-container'>
                {blogs.map(post =>
                    <div key={post.Url} className='blog-section-post'>
                        <h3 className='blog-section-post-title'>
                            <a href={post.Url}>
                                {post.PageHeader}
                            </a>
                        </h3>
                        <div>
                            <span className='blog-section-post-date'><TranslationText tKey='sandhills.dealerservices.boards.mvc.posted' /> {post.DisplayLastUpdate ? post.UpdatedDateFormatted : post.PostedDateFormatted}</span>
                        </div>
                        <div>
                            <span className='blog-section-post-content'>{post.SummaryPlainText}</span>
                        </div>
                        <div>
                            <a href={post.Url}><TranslationText tKey='sandhills.tradepubwebsite.mvc.readthefullblogpost' /></a>
                        </div>
                    </div>)}
            </div>
        </div>
    );
};

export default FullBlogSection;